import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';

export default function SuccessPage({ onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="page-content text-center" style={{ padding: '80px 20px', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <div style={{ fontSize: '4.5rem', marginBottom: '24px', animation: 'float 3s ease-in-out infinite' }}>💖</div>
      <h2 style={{ fontSize: '2rem', fontFamily: 'Outfit', marginBottom: '16px', color: 'var(--text-primary)' }}>Thank You for Reporting!</h2>
      <p style={{ color: 'var(--text-secondary)', marginBottom: '32px', fontSize: '1.02rem', lineHeight: '1.7' }}>
        Your Adverse Drug Reaction (ADR) report has been securely submitted. No password or personal account was created, keeping your access completely private. Your input is critical in helping improve hospital safety standards.
      </p>
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
        <button className="btn btn-primary" onClick={() => navigate(ROUTES.REGISTER_PERSONAL)}>
          📋 Submit Another Report
        </button>
        <button className="btn btn-outline" onClick={onLogout}>
          🚪 Exit Patient Portal
        </button>
      </div>
    </div>
  );
}
